<template>
	<div id="sentiment_market_hot_day">
		<!-- <b-button size="sm"  variant="outline-primary" @click="refresh()">刷新</b-button> -->
		<v-chart class="chart_hot_day" :options="line" @datazoom='onDataZoom($event,line)'/>
		<b-alert show variant="light">
			<ul>
				<li>按照天来量化情绪趋势，主要预判未来1天，其次3天</li>
				<li>趋势A：高位沸点后往下到达冰凉的趋势</li>
				<li>趋势B：低位冰点启动往上到达沸点的趋势</li>
				<li>重点在于尊重趋势，不要逆势操作，控制仓位，增加胜率</li>
				<li>新人注意：不要预判未来，指标出现反转才是反转，趋势的逆转不可预判</li>
			</ul>
		</b-alert>
	</div>
</template>

<script>
	import ECharts from 'vue-echarts'
	import axios from 'axios'
	import Moment from 'moment'

	
	import {
		request_zzquant
	} from "network/request.js"

	const upColor = '#ec0000';
	const upBorderColor = '#8A0000';
	const downColor = '#00da3c';
	const downBorderColor = '#008F28';

	export default {
		props: {
			title: {
				type: String,
				default: "按天情绪热度"
			},
			subText: {
				type: String,
				default: "热度周期"
			},
			zoom_start: {
				type: [Number, String],
				default: 70,
			},
			zoom_end: {
				type: Number,
				default: 100,
			}
		},
		mounted() {
			this.refresh();
			this.timer = setInterval(() => {  //创建定时器
				this.refresh_interval();
			}, 60000);
		},
		components: {
			'v-chart': ECharts
		},
		data() {
			return {
				auto_refresh: 0,
				timer: null, //首先我在data函数里面进行定义定时器名称
				line: {
					title: {
						text: this.title,
						subtext: this.subText,
						left: 0,
						textStyle: {
							color: '#999999'
						},
						subtextStyle: {
							color: '#666666'
						}
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross'
						}
					},axisPointer: {
						link: {xAxisIndex: 'all'},
						// label: {
						// 	backgroundColor: '#777'
						// }
					},
					toolbox: { //下载
						show: true,
						feature: {
							saveAsImage: {}
						}
					},
					legend: {
						top: 10,
						left: 'center',
						data: ['赚钱效应', '亏钱效应', '涨停数'],
						textStyle: {
							color: '#999999'
						},
					},
					visualMap: {
						// top: 10,
						// right: 10,
						type : 'piecewise',
						show: false,
						seriesIndex: 0,
						dimension:1,
						pieces: [
							{min: parseFloat(75), color: upBorderColor },
							{min: parseFloat(45), max: parseFloat(75), color: upColor},
							{min: parseFloat(35), max: parseFloat(45), color: downColor},
							{min: parseFloat(0), max: parseFloat(35), color: downBorderColor},
							],
						outOfRange: {
							symbol: 'rect', 
							symbolSize: [1,1],
							color:upBorderColor,
						}
					},
					grid: [{
							left: '8%',
							right: '8%',
							height: '50%'
						},
						{
							left: '8%',
							right: '8%',
							top: '70%',
							height: '20%'
						}
					],
					xAxis: [{
							gridIndex: 0,
							type: 'category',
							scale: true,
							boundaryGap: false,
							axisLine: {
								onZero: false,
								lineStyle: {
									color: '#666666'
								}
							},
							splitLine: {
								show: false
							},
							splitNumber: 10,
							min: 'dataMin',
							max: 'dataMax',
							show: true,
							axisPointer: {
								z: 100
							},
							axisLabel: {
								fontSize: 10,
								color: '#999999'
							},
						},
						{
							gridIndex: 1,
							type: 'category',
							scale: true,
							// boundaryGap: false,
							axisLine: {
								onZero: false,
								lineStyle: {
									color: '#666666'
								}
							},
							splitLine: {
								show: false
							},
							splitNumber: 10,
							min: 'dataMin',
							max: 'dataMax',
							show: true,
							axisPointer: {
								z: 100
							},
							axisLabel: {
								fontSize: 10,
								color: '#999999'
							},
						}
					],
					yAxis: [{
							gridIndex: 0,
							name: "热度",
							scale: true,
							position: 'right',
							min: 0,
							max: 100,
							splitNumber: 10,
							axisLine: {
								lineStyle: {
									color: '#666666',
									width: 1
								}
							},
							splitLine: {
								show: false
							},
							splitArea: {
								show: false
							},
							axisLabel: {
								interval: 0,
								formatter: '{value}',
								color: '#999999'
							},
							nameTextStyle: {
								color: '#999999'
							}
						}, 
						{
							gridIndex: 0,
							// name: "热度",
							min: 0,
							max: 100,
							scale: true,
							offset: 2,
							splitArea: {
								show: false
							},
							axisLine: {
								lineStyle: {
									color: '#666666',
									width: 1
								}
							},
							splitLine: false,
							position: 'left',
						}, {
							gridIndex: 1,
							name: "涨停",
							scale: true,
							position: 'right',
							min: 0,
							max: 150,
							splitNumber: 10,
							axisLine: {
								lineStyle: {
									color: '#666666',
									width: 1
								}
							},
							axisTick:{
								show:true
							},
							splitLine: {
								show: false
							},
							splitArea: {
								show: false
							},
							axisLabel: {
								interval: 0,
								formatter: '{value}',
								color: '#999999'
							},
							nameTextStyle: {
								color: '#999999'
							}
						},
						{
							gridIndex: 1,
							name: "连板高度",
							scale: true,
							position: 'left',
							min: 0,
							max: 12,
							splitNumber: 10,
							axisLine: {
								lineStyle: {
									color: '#666666',
									width: 1
								}
							},
							axisTick:{
								show:true
							},
							splitLine: {
								show: false
							},
							splitArea: {
								show: false
							},
							axisLabel: {
								interval: 0,
								formatter: '{value}',
								color: '#999999'
							},
							nameTextStyle: {
								color: '#999999'
							}
						},
					],
					dataZoom: [
						// {
						// 	type: 'inside',
						// 	start: this.zoom_start,
						// 	end: this.zoom_end
						// },
						{
							show: true,
							type: 'slider',
							xAxisIndex: [0, 1],
							y: '90%',
							start: this.zoom_start,
							end: this.zoom_end,
							textStyle: {
								color: '#999999'
							}
						}
					],
					series: []
				}
			}
		},
		methods: {
			refresh_interval(){
				if(!this.auto_refresh) return;
				let  myDate = new Date();
				let day = myDate.getDay() //获取当前星期X(0-6,0代表星期天)
				let hour = myDate.getHours(); //获取当前小时数(0-23)
				if (0<day && day<6 && 9<=hour && hour<=15){
					this.refresh();
				}else{
					console.log("day 非交易时间不刷新");
				}
			},
			refresh(data_start) {
				let url = '/v3/api/sentiment/market/hot/day?date='
				if(data_start){
					url += data_start
				}else{
					url += Moment().add(-6,'months').format('YYYY-MM-DD'); 
				}
				axios.all([
						request_zzquant({
							'url': url
						}),
						// request_zzquant({
						// 	'url': '/open/sentiment/hot/today'
						// }),
					])
					.then(axios.spread((resp1) => {
						let splitDataItem = this.splitData(resp1['data']['data']);
						let series_data = []
						// console.log(splitDataItem);
						series_data.push({
							name: '按天情绪',
							data: splitDataItem.earn_effect,
							type: 'line',
							symbol: 'circle',
							showSymbol: true,
							xAxisIndex: 0,
							yAxisIndex: 0,	// 对应上面定义的y轴数据的格式，数组的下标进行对应
							markLine: {
								symbol:'none',//去掉箭头
								data: [{
										// silent: false,
										lineStyle: { //警戒线的样式  ，虚实  颜色
											width: 1,
											type: "solid",
											symbol: 'circle',
											color: upBorderColor,
										},
										label: {
											position: 'end',
											formatter: "沸点风险(90)"
										},
										yAxis: 90
									},
									{
										// silent: false,
										lineStyle: { //警戒线的样式  ，虚实  颜色
											type: "dotted",
											color: upBorderColor,
										},
										label: {
											position: 'end',
											formatter: "过热(75)"
										},
										yAxis: 75
									},
									{
											// silent: false,
											lineStyle: { //警戒线的样式  ，虚实  颜色
												type: "dashed",
												symbol: 'circle',
												color: downBorderColor,
											},
											label: {
												position: 'end',
												formatter: "微冷(45)"
											},
											yAxis: 45
										}, {
											// silent: false,
											lineStyle: { //警戒线的样式  ，虚实  颜色
												type: "dotted",
												symbol: 'circle',
												color: downBorderColor,
											},
											label: {
												position: 'end',
												formatter: "过冷(35)"
											},
											yAxis: 35
										},
										{
											// silent: false,
											lineStyle: { //警戒线的样式  ，虚实  颜色
												width: 1,
												type: "solid",
												color: downBorderColor,
											},
											label: {
												position: 'end',
												formatter: "冰点机会(25)"
											},
											yAxis: 25
										}
								]
							},
							lineStyle: {
								normal: {
									width: 2,
									opacity: 0.9,
									// color: upColor
								}
							},
							
						});

						series_data.push({
							xAxisIndex: 0,
							yAxisIndex: 0,	//数组里面的下标对应
							name: '亏钱效应',
							data: splitDataItem.lose_effect,
							type: 'line',
							symbol: 'circle',
							showSymbol: true,
							lineStyle: {
								normal: {
									width: 2,
									opacity: 0.9,
									color: downColor
								}
							},
							markLine: {
								symbol:'none',//去掉箭头
								data:splitDataItem.mark_line_day1
							}
						});

						series_data.push({
							xAxisIndex: 1,
							yAxisIndex: 2,
							name: '涨停数',
							data: splitDataItem.zt_num,
							type: 'bar',
							itemStyle: {
								normal: {
									width: 1,
									opacity: 0.7,
									color: upColor
								}
							},
							label: {
								show: true,
								position: 'top',
							},
							symbol: 'circle',
							markLine: {
								symbol:'none',//去掉箭头
								data:splitDataItem.mark_line_mon
							}
						});
						
						series_data.push({
							xAxisIndex: 1,
							yAxisIndex: 3,
							name: '连板高度',
							data: splitDataItem.lb_high,
							type: 'line',
							itemStyle: {
								normal: {
									width: 1,
									opacity: 0.7,
									color: upColor
								}
							},
							label: {
								show: true,
								position: 'top',
							},
							symbol: 'circle'
						});
						


						this.line['xAxis'] = [
							{data: splitDataItem.categoryData},
							{data: splitDataItem.categoryData},
							];
						
						this.line['series'] = series_data;
						this.line.legend.data = ['按天情绪'];
					}))
					.catch(err => {
						console.log(err);
					})
			},
			onDataZoom(event,option){
				if(event.type == 'datazoom'){
					let last_end = event.end
					if(event.start == 0){
						let data_start = Moment(option.xAxis[0].data[0])
						if(data_start <= Moment('2019-09-02')){
							return
						}
						let data_start_new = data_start.add(-6,'months').format("YYYY-MM-DD")
						// console.log(data_start_new)
						this.line.dataZoom[0].start=10
						this.line.dataZoom[0].end=last_end
						this.refresh(data_start_new)
					}
					
				}
				// console.log(option)
			},
			splitData(rawData) {
				let [categoryData, earn_effect, lose_effect, lb_high, zt_num] = [
					[],
					[],
					[],
					[],
					[]
				];
				let [mark_line_mon, mark_line_day1] = [[],[]];
				let pre_month = -1;
				//解构赋值
				// let item2 = rowData2['info'][0];
				// if (rawData[0]['date'] < item2['Day']) {
				// 	categoryData.push(item2['Day']);
				// 	earn_effect.push(item2['strong']);
				// 	lose_effect.push(item2['df_num']);
				// 	lb_high.push(item2['lbgd']);
				// 	zt_num.push(item2['ztjs']);
				// }
				rawData.forEach(item => {
					let item_date = item['date']
					categoryData.push(item_date);
					earn_effect.push(item['earn_effect']);
					lose_effect.push(item['lose_effect']);
					lb_high.push(item['lb_high']);
					zt_num.push(item['zt_num']);
					
					// 计算周一
					if(Moment(item_date).weekday()==1){
						mark_line_mon.push({
							xAxis:item_date,
							label: {formatter: item_date.substr(8)},
							})
					}
					if(Moment(item_date).month()!=pre_month){
						mark_line_day1.push({
							name:"月初", 
							label: {formatter: item_date.substr(5)},
							xAxis:item_date})
						pre_month = Moment(item_date).month()
					}
				})
				return {
					categoryData: categoryData,
					earn_effect: earn_effect,
					lose_effect: lose_effect,
					lb_high: lb_high,
					zt_num: zt_num,
					mark_line_mon: mark_line_mon,
					mark_line_day1: mark_line_day1,
				};
			},
			// 最后在beforeDestroy()生命周期内清除定时器：
			beforeDestroy() {
				clearInterval(this.timer);        
				this.timer = null;
			}
		}
	}
</script>

<style scoped>
.chart_hot_day {
	width: 100% !important;
	height: 400px !important;
}
</style>
